<template>
  <v-app>
    <v-content>
      <div>
        <v-btn class="button logout" v-on:click="logout">Logout</v-btn>

        <v-data-table
          :headers="headers"
          :items="people"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.first_name }}</td>
            <td class="text-xs-center">{{ props.item.last_name }}</td>
            <td class="text-xs-center">{{ props.item.year }}</td>
            <td class="text-xs-center">{{ props.item.branch }}</td>
            <td>
              <v-btn v-show="canDeletePerson()" class="button" @click="deletePerson(props.item.id)">
                Delete
              </v-btn>
              <v-btn class="button" @click="editPerson(props.item)">
                Edit
              </v-btn>
            </td>
          </template>
        </v-data-table>

        <h2>{{ this.addEditHeaderText }} Person</h2>
        <div><span v-bind:class="{ 'error': hasError }">{{ errorMessage }}</span></div>
        <v-form @submit="addPerson(first_name, last_name, batch_year, branch)">
           <v-container>
             <v-layout>
              <v-flex
                xs12
                md3>
                  <v-text-field v-model="$v.first_name.$model" label="First Name *" required></v-text-field>
              </v-flex>  
              <v-flex
                xs12
                md3>
                <v-text-field v-model="$v.last_name.$model" label="Last Name *" required></v-text-field>
              </v-flex>  
              <v-flex
                xs12
                md3>
                <v-combobox
                  v-model="batch_year"
                  :items="batch_years"
                  label="Select year graduated"
                ></v-combobox>
              </v-flex>
              <v-flex
                xs12
                md3>
                <v-combobox
                  v-model="branch"
                  :items="branches"
                  label="Select branch"
                ></v-combobox>
              </v-flex>
              <v-btn type="submit" class="button">{{ this.addEditButtonText }}</v-btn>
           </v-layout>
           </v-container>
        </v-form>
      </div>
    </v-content>
    
  </v-app>  
  
</template>

<script>
import firebase from 'firebase'
import { db } from '../main'
import { required } from 'vuelidate/lib/validators'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAUDCnut94cm1w04r0HTcjjZDpSaJcXD4o",
    authDomain: "pec-dmv.firebaseapp.com",
    databaseURL: "https://pec-dmv.firebaseio.com",
    projectId: "pec-dmv",
    storageBucket: "pec-dmv.appspot.com",
    messagingSenderId: "1055532404430"
}
firebase.initializeApp(config)

const dbCollection = 'people' // people-dev for development

export default {
  name: 'People',
  data () {
    return {
      headers: [
        {
          text: 'First Name',
          value: 'first_name',
          align: 'center'
        },
        {
          text: 'Last Name',
          value: 'last_name',
          align: 'center'
        },
        {
          text: 'Graduation Year',
          value: 'year',
          align: 'center'
        },
        {
          text: 'Branch',
          value: 'branch',
          align: 'center'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      people: [],
      person_id: 0,
      first_name: '',
      last_name: '',
      batch_year: '',
      branch: '',
      batch_years: [],
      errorMessage: '',
      hasError: false,
      addEditButtonText: 'Add',
      addEditHeaderText: 'Add A New ',
      branches: ['Aerospace', 'Civil', 'Computer Science', 'Electrical', 'Electronics', 
                 'Industrial/Production', 'Mechanical', 'Metallurgical']
    }
  },
  validations: {
    first_name: {
      required
    },
    last_name: {
      required
    },
    batch_year: {
      required
    },
    branch: {
      required
    }
  },
  firestore () {
    return {
      people: db.collection(dbCollection).orderBy('createdAt')
    }
  },
  mounted () {
    this.batch_year = this.defaultBatchYear()
    this.loadPeople()
    this.batch_years = this.allBatchYears()
  },
  methods: {
    addPerson (first_name, last_name, year, branch) {
      let self = this
      const createdAt = new Date()
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log("Invalid form")
        this.errorMessage = 'Required fields missing'
        this.hasError = true
      } else {
        this.errorMessage = ''
        this.hasError = false
        if (this.person_id != 0) {
          db.collection(dbCollection).doc(this.person_id).update(
            { 
              first_name: first_name, 
              last_name: last_name,
              year: year,
              branch: branch
            })
          this.updatePeople(this.person_id)
          this.resetForm()
        } else {
          db.collection(dbCollection).add({ first_name, last_name, year, 
            createdAt }).then(doc => {
            // Clear values
            self.first_name = ''
            self.last_name = ''
            self.batch_year = this.defaultBatchYear()
            let data = {}
            data["id"] = doc.id
            data["first_name"] = first_name
            data["last_name"] = last_name
            data["year"] = year
            self.person_id = 0 
            self.people.push(data)
          })
        }
        
      }
    },
    deleteComic (id) {
      let self = this
      let deletedComic = db.collection('comics').doc(id).delete()
      for( var i = 0; i < self.comics.length; i++){ 
        if ( self.comics[i].id == id) {
          self.comics.splice(i, 1)
        }
      }
    },
    deletePerson (id) {
      let self = this
      let deletedPerson = db.collection(dbCollection).doc(id).delete()
      for( var i = 0; i < self.people.length; i++){ 
        if ( self.people[i].id == id) {
          self.people.splice(i, 1)
        }
      }
      this.resetForm()
    },
    editPerson (person) {
      this.person_id = person.id
      this.first_name = person.first_name
      this.last_name = person.last_name
      this.batch_year = person.year
      this.branch = person.branch
      this.addEditButtonText = 'Edit'
      this.addEditHeaderText = 'Edit'
    },
    defaultBatchYear() {
      let today = new Date()
      return today.getFullYear()
    },
    logout () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    },
    loadComics() {
      let comicsRef = db.collection('comics').orderBy('createdAt')
      this.comics = []
      comicsRef.get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                console.log(doc.id)
                let data = doc.data()
                data["id"] = doc.id
                this.comics.push(data)
            })
        })
    },
    loadPeople() {
      let peopleRef = db.collection(dbCollection).orderBy('createdAt')
      this.people = []
      peopleRef.get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                let data = doc.data()
                data["id"] = doc.id
                this.people.push(data)
            })
        })
    },
    allBatchYears() {
      let max = this.defaultBatchYear()
      let min = 1970
      let years = []
      for(var i = min; i < max+1; i++) {
        years.push(i)
      }
      return years
    },
    updatePeople(id) {
      for( var i = 0; i < this.people.length; i++){ 
        if ( this.people[i].id == id) {
          this.people.splice(i, 1, 
          {
            first_name: this.first_name,
            last_name: this.last_name,
            year: this.batch_year,
            branch: this.branch,
            id: id
          })
        }
      }
    },
    canDeletePerson() {
      if (firebase.auth().currentUser.email == 'navjeetc@gmail.com') return true
      return false
    },
    resetForm() {
      // Clear values
      this.first_name = ''
      this.last_name = ''
      this.batch_year = this.defaultBatchYear()
      // Switch to Add mode
      this.addEditButtonText = 'Add'
      this.addEditHeaderText = 'Add A New' 
      this.person_id = 0 
    }
  }
}
</script>

<style scoped>
  .error {
    color: white;
    background-color: white;
    padding: 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/People.vue